
import { motion } from "framer-motion";
import { useTheme } from "@/contexts/ThemeContext";
import { Card, CardContent } from "./ui/card";

export const OurStory = () => {
  const { colors, theme } = useTheme();

  // Optimized animation durations for mobile
  const isMobile = window.innerWidth < 768;
  const animationDuration = isMobile ? 0.4 : 0.6;

  return (
    <section 
      id="our-story" 
      className="py-16 md:py-24"
      style={{ backgroundColor: colors.background }}
    >
      <div className="max-w-6xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }} // Reduced from 30
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: animationDuration }}
          className="text-center mb-16"
        >
          <h2 
            className="text-4xl md:text-5xl font-bold mb-4 pb-2"
            style={{
              background: colors.gradient,
              backgroundSize: "200% auto",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Our Story
          </h2>
          <motion.div
            className="w-24 h-1 mx-auto"
            style={{ backgroundColor: colors.primary }}
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true }}
            transition={{ duration: animationDuration, delay: 0.2 }} // Reduced delay
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }} // Reduced from 30
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: animationDuration, delay: 0.1 }} // Reduced delay
        >
          <Card 
            className="backdrop-blur-sm border"
            style={{ 
              backgroundColor: theme === 'light' ? colors.card : `${colors.card}95`,
              borderColor: `${colors.border}60`
            }}
          >
            <CardContent className="p-8 md:p-12">
              <div className="grid md:grid-cols-2 gap-8 items-center">
                <motion.div
                  initial={{ opacity: 0, x: -20 }} // Reduced from -30
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: animationDuration, delay: 0.2 }} // Reduced delay
                >
                  <h3 
                    className="text-2xl md:text-3xl font-bold mb-6"
                    style={{ color: colors.foreground }}
                  >
                    Where Vision Gets Viral
                  </h3>
                  <p 
                    className="text-lg leading-relaxed mb-6"
                    style={{ color: colors.secondary }}
                  >
                    Founded in 2016, Agape began with a simple mission: to support those who bring stories to life. What started with celebrity management soon evolved into a full-fledged creative house-spanning production, distribution, strategy, and beyond.
                    With every project, we infuse heart, hustle, and high standards. We protect talent, promote stories, and empower creators through thoughtful execution and deep industry know-how. We are more than a company-we are partners in your creative journey.
                  </p>
                </motion.div>
                
                <motion.div
                  initial={{ opacity: 0, x: 20 }} // Reduced from 30
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: animationDuration, delay: 0.3 }} // Reduced delay
                  className="relative"
                >
                  <div 
                    className="rounded-lg overflow-hidden shadow-2xl"
                    style={{ backgroundColor: `${colors.primary}20` }}
                  >
                    <img 
                      src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                      alt="Team collaboration"
                      className="w-full h-64 md:h-80 object-cover"
                    />
                  </div>
                  <motion.div
                    className="absolute -bottom-4 -right-4 w-24 h-24 rounded-full blur-xl"
                    style={{ backgroundColor: `${colors.primary}20` }} // Reduced intensity
                    animate={{
                      scale: [1, 1.1, 1], // Reduced scale
                      opacity: [0.2, 0.4, 0.2] // Reduced opacity
                    }}
                    transition={{
                      duration: isMobile ? 2 : 2.5, // Faster on mobile
                      repeat: Infinity,
                      ease: "easeInOut"
                    }}
                  />
                </motion.div>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </section>
  );
};
